module.exports = __webpack_public_path__ + "509abff79549edd92386996c108d11f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/madlaina-kalunder.jpg
// module id = 516
// module chunks = 0